import { FC, useContext, useMemo } from 'react';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailReceived: FC<{ id: number }> = ({ id }) => {
  const { redeliveryDetails } = useContext(RedeliveryContext);

  const received = useMemo(() => redeliveryDetails.get(id)?.received ?? 0, [id, redeliveryDetails]);

  return (
    <div className="text-field">
      <input className="w-100" type="number" defaultValue={received} disabled />
      <label>RECEIVED</label>
    </div>
  );
};

export default RedeliveryDetailReceived;
